import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const BoxWrapper: CSSObject = {
  borderRadius: ['none', 'base'],
  mb: '3',
  mx: ['-2', '0'],
  px: ['2', '0'],
  mt: '1',
  gap: '1',
  borderEnd: '1px solid',
  borderEndColor: 'gray.200',
  pl: ['0', null, '1.5'],
  h: 'fit-content',
  '&:has(+ .subTabBar)': {
    borderBottomRadius: 'none',
    mb: '0',
  },
  '&.tabBar': {
    bg: 'alpha.600',
    boxShadow: '0px 3px 3px 0px rgba(0, 0, 0, 0.20) inset',
    borderRadius: ['none', 'lg'],
    h: 'fit-content',
    mt: 2,
    pb: '0',
    '&:has(+ .subTabBar)': {
      pb: '0',
      borderBottomRadius: 'none',
    },
  },
  '&.subTabBar': {
    bg: 'alpha.300',
    borderBottomRadius: ['none', 'lg'],
    borderTopRadius: 'none',
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.10)',
    mt: 0,
    pb: '0',
    h: 'fit-content',
  },
};

export const buttonTabBarProps: CustomButtonProps = {
  variant: 'quaddiesTab',
  sx: {
    '&&': {
      marginLeft: '0',
      marginRight: '0',
      _hover: {
        borderColor: 'alpha.300',
      },
    },
    py: '2',
    '&&[data-active="true"]': {
      bg: 'alpha.300',
      borderBottom: 'none',
      h: '34px',
      '& > span': {
        borderRadius: '3px',
        padding: '1',
        bg: 'alpha.800',
        color: 'alpha.300',
        fontWeight: 'bold',
        fontSize: 'xs',
      },
    },
    '&&[data-active]': {
      borderRadius: 'none',
    },
    '&.subTab': {
      color: 'alpha.700',
      _hover: {
        borderBottomColor: 'alpha.700',
      },
    },
  },
};

export const buttonTabBarMeetingsProps: CustomButtonProps = {
  variant: 'tab',
};

export const tickForToteMulti: CSSObject = {
  position: 'absolute',
  width: '11px',
  height: '11px',
  bg: '#426DD6',
  top: '-5px',
  right: '-5px',
  borderRadius: '3px',
  _before: {
    content: "' '",
    height: '6px',
    width: '2px',
    backgroundColor: 'white',
    position: 'absolute',
    top: '2px',
    right: '3px',
    transform: 'rotate(45deg)',
  },
  _after: {
    content: "' '",
    height: '2px',
    width: '4px',
    backgroundColor: 'white',
    position: 'absolute',
    top: '6px',
    right: '5px',
    transform: 'rotate(210deg)',
  },
};
